import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  messageSocket: null,
  videoDefaultUrl: null
}

const mutations = {
  getMessageSocket (state, data) {
    state.messageSocket = data
  },
  clearMessageSocket (state) {
    state.messageSocket = null
  },
  setVideoDefault (state, data) {
    state.videoDefaultUrl = data
  },
  clearVideoDefault (state) {
    state.videoDefaultUrl = null
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store.js